<app-ui-document-panel-shell
  [breadcrumb]="breadcrumb"
  [title]="panelTitle"
  [documentId]="quality_check_no || ''"
  [statusLabel]="statusLabel"
  [statusVariant]="statusVariant"
  (closed)="onClose()">

  <app-ui-approval-stepper
    *ngIf="data?.id"
    [steps]="approvalSteps">
  </app-ui-approval-stepper>

  <app-ui-form-section title="General Information" icon="info">
    <div class="ui-doc-panel-content__field-grid">
      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="outline">
          <mat-label>Select Vendor <span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="vendor" placeholder="Select Vendor" [disabled]="isInputDisabled || !!data?.id" (ngModelChange)="getVendorBranch($event)">
            <mat-option *ngFor="let item of vendordata" [value]="item.vendor_id">
              {{ item.vendor?.vendor_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="outline">
          <mat-label>Vendor Branch Name<span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="branch" placeholder="Select Vendor Branch Name" [disabled]="isInputDisabled"
            (ngModelChange)="fetchpo(vendor,branch)">
            <mat-option *ngFor="let branch of selectedBranch" [value]="branch.id">
              {{ branch.branch_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="outline">
          <mat-label>Select GSRN <span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select #grnSelect [(ngModel)]="grn" panelClass="grn-select-panel" [disabled]="isInputDisabled"
            (openedChange)="onGrnOpen($event)" (ngModelChange)="fetchProfitSection($event)">
            <mat-option disabled class="grn-search-option">
              <input matInput placeholder="Search GRN..." (keyup)="onGrnSearch($event.target.value)"
                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </mat-option>
            <mat-option *ngFor="let item of grn_data" [value]="item.id">
              {{ item.grn_no }}
            </mat-option>
            <mat-option *ngIf="loadingGrn" disabled>Loading…</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="outline">
          <mat-label>Select Profit/Cost Center <span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select #profitCostSelect [(ngModel)]="profitcost" (ngModelChange)="filterSectionsByProfitCost($event)"
            (openedChange)="onProfitCostOpen($event)" multiple [disabled]="isInputDisabled">
            <mat-option disabled>
              <input matInput placeholder="Search Profit/Cost Center..." (keyup)="onProfitCostSearch($event.target.value)"
                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            </mat-option>
            <mat-option *ngFor="let item of profitCostData" [value]="item.id">
              {{ item.name }}
            </mat-option>
            <mat-option *ngIf="loadingProfitCost" disabled>Loading...</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="outline">
          <mat-label>Select Section <span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="section" placeholder="Select Section" [disabled]="isInputDisabled"
            (ngModelChange)="onSectionChange()" multiple>
            <mat-option *ngFor="let section of section_data" [value]="section.id">
              {{ section.section_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="outline">
          <mat-label>Date <span class="ui-doc-panel-content__required">*</span></mat-label>
          <input type="date" matInput [(ngModel)]="date" class="custom-input" [max]="maxDate" [disabled]="isInputDisabled">
        </mat-form-field>
      </div>
    </div>
  </app-ui-form-section>

  <app-ui-form-section title="Line Items" icon="list_alt">
    <div class="ui-doc-panel-content__table-wrap" *ngIf="productList; else noProductData">
      <table class="ui-doc-table">
        <thead>
          <tr>
            <th>Profit/Cost Center</th>
            <th>Section</th>
            <th>Category Name</th>
            <th>Item/Service Name</th>
            <th>Specification</th>
            <th>Description</th>
            <th>Po Quantity</th>
            <th>HSN/SAC No</th>
            <th>UOM</th>
            <th>Start Date</th>
            <th>Delivery Date</th>
            <th>Price</th>
            <th>GSRN Receive Qty</th>
            <th>GSRN Pending Qty</th>
            <th>Qc Acceptance Qty</th>
            <th *ngIf="is_reverse">Reverse Qty</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let product of productList">
            <tr *ngFor="let detail of product.details; let i = index">
              <td>{{detail.profit_cost?.name}}</td>
              <td>{{detail.section?.section_name}}</td>
              <td>{{
                detail.item_service_type === 'SKU'
                ? detail?.sku?.profit_cost_category?.category?.category_name
                : detail.item_service_type === 'Service'
                ? detail?.service?.profit_cost_category?.category?.category_name
                : detail.item_service_type === 'Fixed Asset'
                ? detail?.fa_template?.home_entity_category?.category_name
                : ''
              }}</td>
              <td>{{
                detail.item_service_type === 'SKU'
                ? detail?.sku?.item?.item_name
                : detail.item_service_type === 'Service'
                ? detail?.service?.service_name
                : detail.item_service_type === 'Fixed Asset'
                ? detail?.fa_template?.name
                : ''
              }}</td>
              <td>{{ detail?.specification }}</td>
              <td>{{ detail?.description }}</td>
              <td>{{ detail?.qty | number:'1.3-3'}}</td>
              <td>{{ detail?.hsn_no }}</td>
              <td>{{ detail?.unit?.unit_name }}</td>
              <td>{{ detail?.start_date }}</td>
              <td>{{ detail?.end_date }}</td>
              <td>{{ detail?.price | number: '1.2-2' }}</td>
              <td>{{ detail?.receive_qty | number:'1.3-3'}}</td>
              <td *ngIf="isUpdateMode || is_reverse; else normalMode">
                {{ getInitialTotal(detail) }}
              </td>
              <ng-template #normalMode>
                <td>{{ detail?.receive_qty - detail?.pass_qty_sum | number:'1.3-3'}}</td>
              </ng-template>
              <td>
                <input
                  type="number"
                  [(ngModel)]="detail.pass_qty"
                  placeholder="Qc Qty"
                  min="0.001" step="0.001"
                  [disabled]="isInputDisabled || is_reverse"
                  (keypress)="allowOnlyNumbers($event)"
                />
              </td>
              <td *ngIf="is_reverse">
                <mat-form-field appearance="outline">
                  <input matInput type="number" [(ngModel)]="detail.reverse_qty" min="0.001" step="0.001"
                    (ngModelChange)="onReverseQtyChange(detail)" (keypress)="allowOnlyNumbers($event)" required>
                </mat-form-field>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <ng-template #noProductData>
      <p>No data available.</p>
    </ng-template>
  </app-ui-form-section>

  <app-ui-form-section title="Attachments" icon="attach_file">
    <app-ui-document-file-upload
      [disabled]="isInputDisabled"
      [files]="uploadedFiles"
      [showViewLink]="!!data?.id"
      (filesSelected)="onFileSelected($event)"
      (removeFile)="removeFile($event)"
      (viewFiles)="openQcFileShowModal()">
    </app-ui-document-file-upload>
  </app-ui-form-section>

  <app-ui-form-section title="Remarks" icon="notes">
    <mat-form-field appearance="fill" class="ui-doc-panel-content__remarks">
      <mat-label>Remark</mat-label>
      <textarea matInput [(ngModel)]="remark" placeholder="remark" rows="3" [disabled]="isInputDisabled"></textarea>
    </mat-form-field>
  </app-ui-form-section>

<app-ui-document-panel-footer
  [primaryActions]="footerPrimaryActions"
  [secondaryActions]="footerSecondaryActions"
  [destructiveAction]="footerDestructiveAction"
  [overflowActions]="footerOverflowActions"
  (actionClick)="onFooterAction($event)">
</app-ui-document-panel-footer>

</app-ui-document-panel-shell>
